"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_CHALLENGE_NONE = void 0;
exports.MOCK_CHALLENGE_NONE = {
    type: 'None',
    progressId: '31542466',
};
//# sourceMappingURL=challengeMocks.js.map